import React from "react";
import styled from "styled-components";
import get from 'lodash/get';
import { getCloudinaryUrl } from "../NextBestAction.utils";
var SMALL = 72;
var LARGE = 96;
var DENSITY_MULTIPLIER = 2;
var StyledImage = styled.img.withConfig({
  displayName: "Image__StyledImage",
  componentId: "sc-119k2qm-0"
})(["margin:16px 0 0 16px;height:", "px;@media screen and (min-width:576px){height:", "px;}"], SMALL, LARGE);
export var Image = function Image(_ref) {
  var imageSha = _ref.imageSha;

  if (!imageSha) {
    return null;
  }

  var imgSize = SMALL;

  if (get(window, 'matchMedia')) {
    var mediaQuery = window.matchMedia('(min-width: 576px)');
    imgSize = mediaQuery.matches ? LARGE : SMALL;
  }

  imgSize *= DENSITY_MULTIPLIER;
  var imgSrc = getCloudinaryUrl(imageSha, imgSize, imgSize);
  return React.createElement(StyledImage, {
    src: imgSrc
  });
};